import React from 'react';
import { Select } from 'antd';
import { isNullish } from 'utils/nullish';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n';
import scss from './FilterFieldSelect.scss';

/**
 * 字段搜索匹配文本：当前展示名（含 customLabel / ix 替换结果）、字段内部名、中英文文案。
 * 这样中文界面搜 App Version、英文界面搜「版本」都能命中。
 */
function getFieldOptionSearchHaystack(option, zhFieldLabels, enFieldLabels) {
  const fieldName = option.value;
  return [
    option.label,
    fieldName,
    zhFieldLabels[fieldName],
    enFieldLabels[fieldName],
  ].filter(Boolean).join(' ').toLowerCase();
}

const FilterFieldSelect = ({
  optionGroups,
  value,
  onChange,
}) => {
  const { t } = useTranslation();
  // 固定取 zh/en 资源，不跟当前界面语言走，否则只能搜到当前语言的展示名
  const zhFieldLabels = i18n.getResourceBundle('zh', 'translation')?.issueCrashFilterKey || {};
  const enFieldLabels = i18n.getResourceBundle('en', 'translation')?.issueCrashFilterKey || {};

  return <Select
    style={{ width: '100%' }}
    options={optionGroups}
    allowClear={false}
    showSearch
    optionLabelProp='richLabel'
    placeholder={t('issueCrashFilter.fieldNamePlaceholder')}
    filterOption={(input, option) => {
      // 分组节点（问题级/上报级）不能参与匹配：若这里返回 true，rc-select 会整组保留。
      // 返回 false 后它会再过滤子 option，无匹配项的分组会自动隐藏。
      if (!isNullish(option.options)) {
        return false;
      }
      const keyword = (input || '').trim().toLowerCase();
      if (!keyword) {
        return true;
      }
      return getFieldOptionSearchHaystack(option, zhFieldLabels, enFieldLabels).includes(keyword);
    }}
    value={value}
    onChange={(v) => onChange && onChange(v)}
    popupClassName={scss.filterFieldSelect}
    dropdownMatchSelectWidth={false}
  />;
}

export default FilterFieldSelect;
